// extracted by mini-css-extract-plugin
export var orderSummary = "_nv-0";
export var showMoreLessButton = "_nv-1";